import { useContext } from "react";
import { useLocalization } from "@fluent/react";
import { ContentCard } from "@narmi/design_system";
import { LangSelect } from "cerulean";
import { modules } from "byzantine";
import { getSelectedLocale } from "byzantine/src/l10n/InstanceHelpers";
import { LangSelectContext } from "../../../AppLocalizationProvider";

const { usePreferredLanguage } = modules.userLanguagePreference;

/** The language picked here is the user's preferred language. */
const LanguagePreferenceCard = () => {
  const { l10n } = useLocalization();
  const {
    showLangSelect,
    localeCodes,
    localeNames,
    selectedLocale,
    setSelectedLocale,
  } = useContext(LangSelectContext);
  const { isSaving, setPreferredLanguage } = usePreferredLanguage();

  if (!showLangSelect) {
    return null;
  }

  const onChange = (locale: string) => {
    // A pick made mid-save would show but never be saved
    if (isSaving) {
      return;
    }
    // With nothing saved, selectedLocale is unset while the browser's language shows
    const previousLocale = selectedLocale ?? getSelectedLocale(l10n);
    setSelectedLocale(locale);
    setPreferredLanguage(locale, {
      onError: () => setSelectedLocale(previousLocale),
    });
  };

  return (
    <ContentCard kind="elevated">
      <h4 className="fontFamily--default fontSize--heading4 margin--bottom">
        {l10n.getString("heading-language")}
      </h4>
      <LangSelect
        localeCodes={localeCodes}
        localeNames={localeNames}
        selectedLocale={selectedLocale ?? ""}
        onChange={onChange}
      />
    </ContentCard>
  );
};

export default LanguagePreferenceCard;
